// Copyright 2020 Sorama B.V.

import { PLATFORM } from "aurelia-pal";
import { GuidanceTopicType, IGuidanceTopic } from "catalogs/GuidanceCatalog";
import { WorkflowModuleType } from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";

export class GettingStartedGuidanceCatalog {
    static GettingStartedOverviewModule: IGuidanceTopic = {
        name: "GettingStarted_Overview",
        modulePath: PLATFORM.moduleName("guidance/GettingStarted/Overview.html"),
        title: "Getting Started",
        moduleType: WorkflowModuleType.Help,
        topicType: GuidanceTopicType.TopicOverview,
        topicContent: "Getting Started",
    };

    static GettingStartedGS1Module: IGuidanceTopic = {
        name: "GettingStarted_Q1", // https://sorama.atlassian.net/wiki/spaces/UI/pages/716308487/GS1+How+to+get+started+with+the+camera
        modulePath: PLATFORM.moduleName("guidance/GettingStarted/HowToStart.html"),
        title: "Getting Started",
        moduleType: WorkflowModuleType.Help,

        topicParent: GettingStartedGuidanceCatalog.GettingStartedOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "How to get started with the camera?",
        catchwords: [""],
    };
}
